<template>
  <div class="h-100">
    <main role="main" class="h-100">
      <common-master-table
          primary-key="inductionSerialId"
          table-no="mstInduction"
          table-api="master/induction"
          ref="commonMasterTable"
          :editable="editableMixin.induction.upd"
          :addable="editableMixin.induction.ins"
          :mapping-no="`ie-induction`"
          socket-entity="INDUCTION_SOCKET"
        />
    </main>
  </div>
</template>

<script>
import CommonMasterTable from '../custom-components/CommonMasterTable'
import RouterUtils from '../../_helpers/router.util'
export default {
  components: {
    // コンポーネント分割化
    CommonMasterTable
  },
  data() {
    return {
      removeKeys: [],
      updateQueryStr: ''
    }
  },
  beforeRouteUpdate(to, from) {
    if (to.query && to.query.hasOwnProperty('limit') && Object.keys(to.query).length === 1) {
      RouterUtils.correctTableRowsLimitParam(to.query)
      this.$refs.commonMasterTable.initData()
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/mst-tables/InductionMaster.vue